var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-col",
    _vm._b({ attrs: { cols: "12", sm: _vm.sm } }, "v-col", _vm.$attrs, false),
    [
      _c("v-switch", {
        attrs: {
          color: _vm.color,
          disabled: _vm.disabled,
          inset: "",
          dense: "",
          "hide-details": "",
          hint: "teste de texto",
          "persistent-hint": "",
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _vm.textHelper
                  ? _c("emc-info-help", {
                      attrs: { title: "Informações", text: _vm.textHelper },
                    })
                  : _vm._e(),
                _vm._v(" " + _vm._s(_vm.label) + " "),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }